import { render, staticRenderFns } from "./detailV2.vue?vue&type=template&id=7c260d26&"
import script from "./detailV2.vue?vue&type=script&lang=js&"
export * from "./detailV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports